// extracted by mini-css-extract-plugin
export default {"filterContainer":"FilterTabs_filterContainer__uS9fQ","filterTab":"FilterTabs_filterTab__RXjjY","selected":"FilterTabs_selected__dNjd3","divider":"FilterTabs_divider__iboOH"};